export default "__VITE_ASSET__Cz9FFMo1__"